import styled from "styled-components";

import { useContext } from "react";
import Context from "../../../Context.js";

const Container = styled.div`
  height: 100dvh;
  height: 100dvh;
  width: 100vw;
  /* overflow: hidden; */
  background-color: var(--rootBackgroundColor);
  height: calc(100dvh - var(--safe-area-inset-top));
  width: 100vw;
  /* overflow: hidden; */
  /* overflow-y: scroll; */
`;

const Main = styled.div`
  height: 100dvh;
  height: 100dvh;
  width: 100vw;
  overflow: hidden;
  position: absolute;
  top: 0;
  /* background-color: rgba(0, 0, 0, 0.7); */
  /* backdrop-filter: blur(80px); */
  left: 0;
  z-index: 2;

  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100dvh - var(--safe-area-inset-top));
  overflow-y: scroll;
`;

const Background = styled.img`
  height: 100dvh;
  height: 100dvh;
  width: 100vw;
  object-fit: cover;
`;

export default function WithBackground({ children, backgroundImage }) {
  const { loggedInUserID, colorMode } = useContext(Context);

  // return children;

  if (!backgroundImage) return children;

  return (
    <Container>
      <Main>{children}</Main>
      {/* {backgroundImage ? <Background src={backgroundImage} /> : null} */}
    </Container>
  );
}
